import { Pipe, PipeTransform } from '@angular/core';

const BOARD_TYPE_NAMES: Record<string, string> = {
    accordingDescription: 'Laut Beschreibung',
    allInclusive: 'All Inclusive',
    allInclusiveEconomy: 'All Inclusive Economy',
    allInclusiveSuperior: 'All Inclusive Superior',
    breakfast: 'Frühstück',
    breakfastEconomy: 'Frühstück Economy',
    breakfastSuperior: 'Frühstück Superior',
    fullBoard: 'Vollpension',
    fullBoardEconomy: 'Vollpension Economy',
    fullBoardSuperior: 'Vollpension Superior',
    halfBoard: 'Halbpension',
    halfBoardEconomy: 'Halbpension Economy',
    halfBoardSuperior: 'Halbpension Superior',
    noBoard: 'Ohne Verpflegung',
    selfCatering: 'Selbstverpflegung',
};

@Pipe({
    name: 'boardTypeName',
    standalone: false
})
export class BoardTypeNamePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }

        return BOARD_TYPE_NAMES[value] || value;
    }
}
